// eslint-disable-next-line import/no-anonymous-default-export
export default {
  AuthPageUser: {
    title: 'Авторизация',
  },
  ErrorCodeMessage: {
    errorCodeTitleTemplate: 'Ошибка %errorCodeTitle%.',
    identificatorText: 'Идентификатор:',
    timestampText: 'Время:',
    defaultErrorCodeTitle: 'ApplicationError',
    defaultErrorDescription: 'Что‑то пошло не так',
  },
  ClosedModal: {
    title: 'Проект закончился',
    description: 'Но\u00a0если очень хочется, можно его посмотреть и\u00a0пощелкать',
    button: 'Всё понятно',
    img: {
      src: 'static/ny25/projectClosed-2025-03-06-03-35-40.svg',
      alt: 'Проект закончился',
    },
  },
  ErrorDefault: {
    title: 'Что‑то пошло не так',
    text: 'Попробуйте перезагрузить страницу или вернуться позже',
  },
  topBar: {
    backButtonText: 'Назад',
  },
  backToItems: {
    buttonText: 'К конфетам',
  },
  completionModal: {
    candyImage: {
      src: {
        png: 'static/ny25/HappyCandy-320-2024-12-20-12-29-26.png 320w, static/ny25/HappyCandy-600-2024-12-20-12-29-26.png 854w',
        avif: 'static/ny25/HappyCandy-320-2024-12-20-12-29-26.avif 320w, static/ny25/HappyCandy-600-2024-12-20-12-29-26.avif 854w',
        webp: 'static/ny25/HappyCandy-320-2024-12-20-12-29-26.webp 320w, static/ny25/HappyCandy-600-2024-12-20-12-29-26.webp 854w',
      },
      alt: 'конфета',
    },
    buttonText: 'Понятно',
    OpenedAll: {
      title: 'Секрет конфет раскрыт!',
      description:
        'Вы развернули все конфеты, которые мы вам приготовили. Так держать! Не забудьте использовать полученные бонусы',
    },
    ProjectFinishesSoon: {
      title: '',
      description: 'Успейте развернуть конфеты и получить бонусы, пока спецпроект не закончился',
    },
    ProjectFinished: {
      title: 'Спасибо за участие!',
      description:
        'Спецпроект закончился: разворачивать конфеты уже не получится, но вы можете посмотреть открытую статистику трат и использовать полученные бонусы',
    },
  },
  userEnergyModal: {
    title: 'Доступные бонусы',
    closeButtonText: 'Закрыть',
  },
  itemDisabledModal: {
    title: 'увы!',
    description: 'У вас закончились попытки! Возвращайтесь каждые 8 часов, чтобы открывать новые конфеты',
    buttonText: 'Понятно',
  },
  mainPageWeb: {
    title: {
      description: 'Ваши траты за год в новогоднем спецпроекте от Т‑Банка',
      titleImage: {
        src: {
          png: 'static/ny25/kv-320-2024-10-30-09-54-27.png 320w, static/ny25/kv-780-2024-10-30-09-54-27.png 854w',
          avif: 'static/ny25/kv-320-2024-10-30-09-54-27.avif 320w, static/ny25/kv-780-2024-10-30-09-54-27.avif 854w',
          webp: 'static/ny25/kv-320-2024-10-30-09-54-27.webp 320w, static/ny25/kv-780-2024-10-30-09-54-27.webp 854w',
        },
        alt: 'заголовок',
      },
      logoImage: {
        src: {
          png: 'static/ny25/tLogo-320-2024-12-04-07-47-09.png 320w, static/ny25/tLogo-360-2024-12-04-07-47-09.png 854w',
          avif: 'static/ny25/tLogo-320-2024-12-04-07-47-09.avif 320w, static/ny25/tLogo-360-2024-12-04-07-47-09.avif 854w',
          webp: 'static/ny25/tLogo-320-2024-12-04-07-47-09.webp 320w, static/ny25/tLogo-360-2024-12-04-07-47-09.webp 854w',
        },
        alt: 'Т‑Банк',
      },
      button: {
        text: 'Перейти в приложение',
        href: 'https://l.tbank.ru/ny25_main_mobile',
      },
      qr: {
        title: 'Перейти в приложение',
        image: {
          src: {
            png: 'static/ny25/qrWeb-320-2024-12-04-12-40-14.png 320w, static/ny25/qrWeb-854-2024-12-04-12-40-14.png 854w, static/ny25/qrWeb-1280-2024-12-04-12-40-14.png 1387w',
            avif: 'static/ny25/qrWeb-320-2024-12-04-12-40-14.avif 320w, static/ny25/qrWeb-854-2024-12-04-12-40-14.avif 854w, static/ny25/qrWeb-1280-2024-12-04-12-40-14.avif 1387w',
            webp: 'static/ny25/qrWeb-320-2024-12-04-12-40-14.webp 320w, static/ny25/qrWeb-854-2024-12-04-12-40-14.webp 854w, static/ny25/qrWeb-1280-2024-12-04-12-40-14.webp 1387w',
          },
          alt: 'QR‑код',
        },
      },
    },
    statistic: {
      title: 'Общая статистика',
      description:
        'Переходите в проект, чтобы посмотреть свою персональную статистику 2024 года и получить бонусы или пожелания от амбассадоров Т‑Банка',
    },
    card: {
      title: 'Дебетовая карта Black',
      description: 'Зарабатывайте кэшбэк рублями, а не бонусами',
      image: {
        src: {
          png: 'static/ny25/card-320-2024-12-02-08-37-19.png 320w, static/ny25/card-854-2024-12-02-08-37-19.png 854w, static/ny25/card-1387-2024-12-02-08-37-19.png 1387w, static/ny25/card-1920-2024-12-02-08-37-19.png 1920w',
          avif: 'static/ny25/card-320-2024-12-02-08-37-19.avif 320w, static/ny25/card-854-2024-12-02-08-37-19.avif 854w, static/ny25/card-1387-2024-12-02-08-37-19.avif 1387w, static/ny25/card-1920-2024-12-02-08-37-19.avif 1920w',
          webp: 'static/ny25/card-320-2024-12-02-08-37-19.webp 320w, static/ny25/card-854-2024-12-02-08-37-19.webp 854w, static/ny25/card-1387-2024-12-02-08-37-19.webp 1387w, static/ny25/card-1920-2024-12-02-08-37-19.webp 1920w',
        },
        alt: 'карта black',
      },
      cardBonuses: [
        {
          id: 1,
          title: 'Кэшбэк рублями до 30%',
        },
        {
          id: 2,
          title: 'Бесплатное обслуживание при остатке на счетах от 50 000 ₽. И 99 ₽ в месяц — если меньше',
        },
        {
          id: 3,
          title: 'Платежи и переводы без комиссии',
        },
      ],
      pointImage: {
        src: {
          png: 'static/ny25/point-66-2024-12-02-08-45-15.png 320w',
          avif: 'static/ny25/point-66-2024-12-02-08-45-15.avif 320w',
          webp: 'static/ny25/point-66-2024-12-02-08-45-15.webp 320w',
        },
        alt: 'точка',
      },
    },
    findProject: {
      title: 'Как найти проект в приложении',
      subTitle: 'В приложении Т‑Банка',
      description: 'Перейдите в раздел «Город» или используйте поиск',
      instruction: {
        link: {
          text: 'Инструкция: как установить приложение Т‑Банка ',
          href: 'https://www.tbank.ru/apps',
        },
        text: '— на случай, если вы клиент, но приложения нет',
        button: {
          text: 'Перейти в приложение',
          link: 'https://l.tbank.ru/ny25_main_mobile',
        },
      },
      iphoneImage: {
        src: {
          png: 'static/ny25/phone-320-2024-12-02-08-39-57.png 320w, static/ny25/phone-480-2024-12-02-08-39-57.png 854w',
          avif: 'static/ny25/phone-320-2024-12-02-08-39-57.avif 320w, static/ny25/phone-480-2024-12-02-08-39-57.avif 854w',
          webp: 'static/ny25/phone-320-2024-12-02-08-39-57.webp 320w, static/ny25/phone-480-2024-12-02-08-39-57.webp 854w',
        },
        alt: 'телефон',
      },
      qr: {
        title: 'Открыть приложение',
        image: {
          src: {
            png: 'static/ny25/qrWeb-320-2024-12-04-12-40-14.png 320w, static/ny25/qrWeb-854-2024-12-04-12-40-14.png 854w, static/ny25/qrWeb-1280-2024-12-04-12-40-14.png 1387w',
            avif: 'static/ny25/qrWeb-320-2024-12-04-12-40-14.avif 320w, static/ny25/qrWeb-854-2024-12-04-12-40-14.avif 854w, static/ny25/qrWeb-1280-2024-12-04-12-40-14.avif 1387w',
            webp: 'static/ny25/qrWeb-320-2024-12-04-12-40-14.webp 320w, static/ny25/qrWeb-854-2024-12-04-12-40-14.webp 854w, static/ny25/qrWeb-1280-2024-12-04-12-40-14.webp 1387w',
          },
          alt: 'QR‑код',
        },
      },
    },
  },
  mainPageMb: {
    title: {
      image: {
        src: {
          png: 'static/ny25/kv-320-2024-10-30-09-54-27.png 320w, static/ny25/kv-780-2024-10-30-09-54-27.png 854w',
          avif: 'static/ny25/kv-320-2024-10-30-09-54-27.avif 320w, static/ny25/kv-780-2024-10-30-09-54-27.avif 854w',
          webp: 'static/ny25/kv-320-2024-10-30-09-54-27.webp 320w, static/ny25/kv-780-2024-10-30-09-54-27.webp 854w',
        },
        alt: 'заголовок',
      },
      description: 'Ваши траты за год в новогоднем подарке от Т‑Банка',
      buttonText: 'Посмотреть конфеты',
    },
    items: {
      title: 'Раскройте сладкие моменты года',
      projectFinishedTitle: 'Все конфеты разобрали',
      description:
        'Разворачивайте конфеты каждый день и узнавайте свои итоги 2024 года с Т‑Банком. В фантиках вас ждут приятные сюрпризы',
      projectFinishedDescription:
        'Мы раздали все бонусы и подвели итоги 2024 года. Следите за новостями — в 2025\u2011м приготовим еще много сюрпризов!',
      energyText: 'Можно открыть еще',
      allItemsOpenedEnergyText: 'Вы открыли все конфеты',
      bonusAcquiredText: 'Бонус у вас',
      bonusLinkText: 'В бонусы',
      wishesTitle: 'У нас для вас пожелание!',
      userBonusTitle: 'Ваш бонус',
      toMainPageButtonText: 'Назад',
      selectBonusText: 'Выбрать',
      openBonusButtonText: 'Подтвердить выбор',
      waitForBonusButtonText: 'Выдаем бонус',
      loaderItemText: 'Открываем конфету',
      loaderBonusText: 'Выдаем бонус',
    },
    dividerImage: {
      src: {
        png: 'static/ny25/divider-320-2024-10-30-09-57-27.png 320w, static/ny25/divider-828-2024-10-30-09-57-27.png 854w',
        avif: 'static/ny25/divider-320-2024-10-30-09-57-27.avif 320w, static/ny25/divider-828-2024-10-30-09-57-27.avif 854w',
        webp: 'static/ny25/divider-320-2024-10-30-09-57-27.webp 320w, static/ny25/divider-828-2024-10-30-09-57-27.webp 854w',
      },
      alt: 'заголовок',
    },
    charity: {
      title: 'Особенная конфета',
      description:
        'На дне новогоднего гостинца часто остается одна карамелька. Вы можете подарить ей новый смысл — переведите любую сумму в благотворительный фонд на свой выбор. ',
      image: {
        src: {
          png: 'static/ny25/charity-320-2024-12-03-11-21-48.png 320w, static/ny25/charity-574-2024-12-03-11-21-48.png 854w',
          avif: 'static/ny25/charity-320-2024-12-03-11-21-48.avif 320w, static/ny25/charity-574-2024-12-03-11-21-48.avif 854w',
          webp: 'static/ny25/charity-320-2024-12-03-11-21-48.webp 320w, static/ny25/charity-574-2024-12-03-11-21-48.webp 1387w',
        },
        alt: 'благотворительность',
      },
      button: {
        text: 'Выбрать фонд',
        href: 'tcsgames://action/deeplink?deeplink=tinkoffbank://Main/Pay?ProviderGroup=Благотворительность',
      },
    },
    statistic: {
      title: 'Ваша конфетница',
      description: 'Статистика трат за 2024 год. Мы собирали ее вплоть до 1 декабря',
      zeroItems: {
        text: 'Здесь будет ваша статистика, когда вы откроете свою первую конфету',
        image: {
          src: {
            png: 'static/ny25/zeroStatistic-320-2024-10-28-11-56-20.png 320w, static/ny25/zeroStatistic-440-2024-10-28-11-56-20.png 854w',
            avif: 'static/ny25/zeroStatistic-320-2024-10-28-11-56-20.avif 320w, static/ny25/zeroStatistic-440-2024-10-28-11-56-20.avif 854w',
            webp: 'static/ny25/zeroStatistic-320-2024-10-28-11-56-20.webp 320w, static/ny25/zeroStatistic-440-2024-10-28-11-56-20.webp 854w',
          },
          alt: 'заглушка',
        },
        buttonText: 'К конфетам',
      },
    },
  },
  bonusesPageMb: {
    title: 'Бонусы',
    subtitle: 'Какие‑то вы уже получили, а другие еще скрыты внутри конфет',
    tabs: {
      userBonuses: 'Уже у вас',
      bonuses: 'Можно получить',
    },
    moreText: 'Подробнее о бонусе',
    bonusesZeroText: 'Список бонусов пуст',
    bonusesProjectFinishedText: 'Спецпроект завершен. Не забудьте использовать бонусы, которые вы получили',
    userBonusesZeroText: 'У вас пока нет полученных бонусов',
    PromocodeClipboardField: {
      successfulCopyText: 'Скопировано',
    },
    BonusUserCard: {
      buttonDisabledText: 'Бонус заблокирован',
      buttonPendingText: 'Бонус выдается',
    },
  },
  settingsPageMb: {
    share: {
      title: 'Угостить конфетой!',
      description: 'Ваши близкие тоже смогут подвести итоги года и выбрать сладкие подарки по вкусу',
    },
    notifications: {
      title: 'Новые сладости',
      description: 'Напомним о конфетах, которые можно попробовать',
      errorText: 'Не удалось обновить настройки. Попробуйте позже',
    },
    projectDuration: {
      title: 'Сроки проекта',
      description: 'Вспоминайте сладкие моменты и получайте бонусы до 14 января 2025 года',
    },
  },
  conditions: {
    linkText: 'Условия участия',
    pdfLoadErrorText: 'Не удалось загрузить документ',
    copyLinkText: {
      idle: 'Скопировать ссылку на условия',
      success: 'Ссылка скопирована',
      error: 'Ошибка копирования',
    },
    pdfHref: {
      small: 'https://cdn.tbank.ru/static/documents/promo-secret-of-sweets.pdf',
      large: 'https://cdn.tbank.ru/static/documents/promo-secret-of-sweets.pdf',
    },
  },
  closePdfIcon: {
    src: 'static/ny25/closePdfIcon-2024-09-27-11-44-25.svg',
    alt: 'закрыть',
  },
  shareButton: {
    nativeShareText: 'Угостить близких',
    defaultCopyText: 'Скопировать ссылку',
    successfulCopyText: 'Скопировано',
    shareLink: 'https://l.tbank.ru/ny2025_share_link',
  },
  onboarding: {
    title: 'Открытие конфет',
    description:
      'Каждые 8 часов вы получаете возможность открыть новую конфету. Возвращайтесь в проект, введя в поиске «Секрет конфет», или через Город — Игры',
    actionButtonText: 'Понятно!',
    tooltipTail: {
      src: 'static/ny25/tooltipTailTop.svg',
      alt: 'тултип',
    },
  },
  faq: {
    title: 'вопросы и ответы',
    items: [
      {
        id: 1,
        title: 'Как все работает?',
        description: 'Разворачивайте конфеты, подводите свои итоги 2024 года и получайте сладкие подарки.',
      },
      {
        id: 2,
        title: 'Что внутри конфет?',
        description:
          'Вместе с вашей статистикой трат под хрустящей оберткой спрятаны новогодние бонусы и теплые пожелания.',
      },
      {
        id: 3,
        title: 'Сколько длится проект?',
        description: 'Рассказываем о вашей статистике трат и дарим бонусы до 14 января 2025 года.',
      },
      {
        id: 4,
        title: 'Почему в некоторых конфетах нет моей статистики?',
        description: 'Если нам где‑то не хватает данных по вашим тратам, показываем общую сводку по клиентам Т‑Банка.',
      },
      {
        id: 5,
        title: 'Как часто можно открывать конфеты?',
        description: 'Каждый день вы можете разворачивать по три сладости. Выбирайте любые по вкусу.',
      },
      {
        id: 6,
        title: 'Как применить бонусы?',
        description: 'Об этом рассказываем под каждым подарком. Чтобы узнать детали, нажмите «Подробнее».',
      },
      {
        id: 7,
        title: 'Конфеты не открываются. Что делать?',
        description:
          'Напишите в поддержку. Вам помогут. Будет здорово, если вы сразу сделаете скриншот с ошибкой и укажете свою версию приложения',
      },
      {
        id: 8,
        title: 'Как найти проект в приложении?',
        description: 'На главной странице приложения напишите в поиске «Секрет конфет» или разделе «Город» → «Игры».',
      },
      {
        id: 9,
        title: 'Как обновить приложение?',
        description:
          'Если у вас смартфон на Android, то %link%href=https://www.tbank.ru/apps/?internal_source=blog-bank#Android;text=перейдите на наш сайт%link% наш сайт с компьютера или планшета, наведите камеру на QR‑код и отсканируйте его. Если смартфон предупредит, что файл опасный, — нажмите «Все равно скачать», мы гарантируем безопасность файлов. Затем разрешите установку, после этого приложение появится на рабочем столе.%br%%br%Если у вас Айфон, то %link%href=https://www.tbank.ru/apps/ios-bank/;text=воспользуйтесь инструкцией%link% или просто напишите поддержку — вам помогут обновиться.',
      },
    ],
  },
  footer: {
    logo: {
      src: {
        png: 'static/ny25/footerLogo-320-2024-12-06-12-05-48.png 320w, static/ny25/footerLogo-640-2024-12-06-12-05-48.png 854w',
        avif: 'static/ny25/footerLogo-320-2024-12-06-12-05-48.avif 320w, static/ny25/footerLogo-640-2024-12-06-12-05-48.avif 854w',
        webp: 'static/ny25/footerLogo-320-2024-12-06-12-05-48.webp 320w, static/ny25/footerLogo-640-2024-12-06-12-05-48.webp 854w',
      },
      alt: 'логотип',
    },
    note1: 'Проект создан при поддержке',
    note2: 'Т-Data',
    copyright: `© 2006–${new Date().getFullYear()}, АО «ТБанк», официальный сайт, универсальная лицензия ЦБ РФ № 2673`,
    links: [
      {
        title: 'Условия акции',
        href: 'https://cdn.tbank.ru/static/documents/promo-secret-of-sweets.pdf',
      },
      {
        title: 'Программа лояльности «Т‑Банк Таргет»',
        href: 'https://cdn.tbank.ru/static/documents/loyalty-program-target_rules.pdf',
      },
      {
        title: 'Программа лояльности Black',
        href: 'https://cdn.tbank.ru/static/documents/loyalty-program-black.pdf',
      },
      {
        title: 'Тарифы дебетовой карты Black',
        href: 'https://www.tbank.ru/cards/debit-cards/tinkoff-black/tariffs/',
      },
    ],
  },
  divider: {
    mainImage: {
      src: {
        png: 'static/ny25/dividerMain-201-2024-11-25-04-52-55.png 320w',
        avif: 'static/ny25/dividerMain-201-2024-11-25-04-52-55.avif 854w',
        webp: 'static/ny25/dividerMain-201-2024-11-25-04-52-55.webp 320w',
      },
      alt: 'разделитель',
    },
    lineImage: {
      src: {
        png: 'static/ny25/Line-267-2024-11-25-04-53-56.png 320w',
        avif: 'static/ny25/Line-267-2024-11-25-04-53-56.avif 854w',
        webp: 'static/ny25/Line-267-2024-11-25-04-53-56.webp 320w',
      },
      alt: 'стрелка',
    },
  },
  backLightsSmall: {
    src: {
      png: 'static/ny25/BackLights_small-320-2024-12-06-11-40-51.png 320w, static/ny25/BackLights_small-828-2024-12-06-11-40-51.png 854w',
      avif: 'static/ny25/BackLights_small-320-2024-12-06-11-40-51.avif 320w, static/ny25/BackLights_small-828-2024-12-06-11-40-51.avif 854w',
      webp: 'static/ny25/BackLights_small-320-2024-12-06-11-40-51.webp 320w, static/ny25/BackLights_small-828-2024-12-06-11-40-51.webp 854w',
    },
    alt: 'подсветка',
  },
  backLightsLarge: {
    src: {
      png: 'static/ny25/BackLightsLarge-320-2024-11-25-06-22-02.png 320w, static/ny25/BackLightsLarge-854-2024-11-25-06-22-02.png 854w, static/ny25/BackLightsLarge-1387-2024-11-25-06-22-02.png 1387w, static/ny25/BackLightsLarge-1920-2024-11-25-06-22-02.png 1920w',
      avif: 'static/ny25/BackLightsLarge-320-2024-11-25-06-22-02.avif 320w, static/ny25/BackLightsLarge-854-2024-11-25-06-22-02.avif 854w, static/ny25/BackLightsLarge-1387-2024-11-25-06-22-02.avif 1387w, static/ny25/BackLightsLarge-1920-2024-11-25-06-22-02.avif 1920w',
      webp: 'static/ny25/BackLightsLarge-320-2024-11-25-06-22-02.webp 320w, static/ny25/BackLightsLarge-854-2024-11-25-06-22-02.webp 854w, static/ny25/BackLightsLarge-1387-2024-11-25-06-22-02.webp 1387w, static/ny25/BackLightsLarge-1920-2024-11-25-06-22-02.webp 1920w',
    },
    alt: 'подсветка',
  },
  fallbackModal: {
    title: 'Ох, кнопка не работает',
    description: 'Чтобы перевести пожертвование перейдите в приложение Т‑Банк ',
    path: ['Главная', 'Платежи', 'Благотвориетельность'],
    arrowLeft: '→',
    benevolencePathImage: {
      src: {
        png: 'static/ny25/benevolenceScreenPath-320-2024-12-16-06-41-25.png 320w, static/ny25/benevolenceScreenPath-854-2024-12-16-06-41-25.png 854w, static/ny25/benevolenceScreenPath-858-2024-12-16-06-41-25.png 1387w',
        avif: 'static/ny25/benevolenceScreenPath-320-2024-12-16-06-41-25.avif 320w, static/ny25/benevolenceScreenPath-854-2024-12-16-06-41-25.avif 854w, static/ny25/benevolenceScreenPath-858-2024-12-16-06-41-25.avif 1387w',
        webp: 'static/ny25/benevolenceScreenPath-320-2024-12-16-06-41-25.webp 320w, static/ny25/benevolenceScreenPath-854-2024-12-16-06-41-25.webp 854w, static/ny25/benevolenceScreenPath-858-2024-12-16-06-41-25.webp 1387w',
      },
      alt: 'путь до блока "Благотворительность"',
    },
  },
  buggie: {
    href: 'tcsgames://action/deeplink?deeplink=tinkoffbank://Main/Gamification/Projects?projectId=buggie',
  },
};
